import Vue from "vue";
import VueCookies from "vue-cookies";
import axios from "axios";

Vue.use(VueCookies);

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_URL_API
});

axiosInstance.interceptors.request.use(
  function(config) {
    //const token = `Bearer ${VueCookies.get("token")}`;
    const token = localStorage.getItem("ckd");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

var config = {
  headers: { "Access-Control-Allow-Origin": "*" }
};

export const api = {
  get(endpoint) {
    return axiosInstance.get(endpoint, config);
  },
  post(endpoint, body) {
    return axiosInstance.post(endpoint, body, config);
  },
  put(endpoint, body) {
    return axiosInstance.put(endpoint, body, config);
  },
  delete(endpoint) {
    return axiosInstance.delete(endpoint, config);
  },
  valid(result, $router) {
    if (result.erro && result.erroTipo && result.erroTipo == "TOKEN") {
      localStorage.removeItem("ckd");
      $router.go({ name: "login" });
    }
  }
};
